export default __webpack_public_path__ + "static/media/GY.a1df57d3.svg";